module.exports = __webpack_public_path__ + "static/media/information-flow-Isometric.62e2d7cd.svg";